require('./RAStrategyModalCards.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @constants
const {
    CARD_ONE,
    CARD_TWO,
    CARD_THREE,
    CARD_FOUR,
    CARD_FIVE,
} = require('../../raConstants/index');

// @utilites
const { formatText, FormattedText } = require('core/i18n').i18n;

class RAStrategyModalCards extends React.Component {
    render() {
        const { newResultCard, oldResultCard, allDisabled } = this.props;
        const items = [
            {
                id: CARD_ONE,
                countryLabel: formatText('raStrategyItem-raStrategyItem_1'),
                riskText: formatText('raStrategyItem-lowRisk'),
            },
            {
                id: CARD_TWO,
                countryLabel: formatText('raStrategyItem-raStrategyItem_2'),
                riskText: formatText('raStrategyItem-midLowRisk'),
            },
            {
                id: CARD_THREE,
                countryLabel: formatText('raStrategyItem-raStrategyItem_3'),
                riskText: formatText('raStrategyItem-midRisk'),
            },
            {
                id: CARD_FOUR,
                countryLabel: formatText('raStrategyItem-raStrategyItem_4'),
                riskText: formatText('raStrategyItem-midHighRisk'),
            },
            {
                id: CARD_FIVE,
                countryLabel: formatText('raStrategyItem-raStrategyItem_5'),
                riskText: formatText('raStrategyItem-highRisk'),
            },
        ];

        const mappedItems = items.map(item => {
            const { id, countryLabel, riskText } = item;
            const currentClassname = classnames('ra-strategy-modal-card');

            const containerClassname = classnames(
                `ra-strategy-modal-card__container`,
                {
                    [`ra-strategy-modal-card__building-${id}__selected`]:
                        newResultCard === id || oldResultCard === id,
                    [`ra-strategy-modal-card__building-${id}__available`]:
                        newResultCard !== id && oldResultCard !== id,
                    ['ra-strategy-modal-card--is-disabled']: id > newResultCard,
                    ['ra-strategy-modal-card--all-disabled']: allDisabled,
                },
            );

            const countrySelectedClassname = classnames(
                `ra-strategy-modal-card__building-${id}__available__country`,
                {
                    [`ra-strategy-modal-card__building-${id}__available__country__selected`]:
                        newResultCard === id || oldResultCard === id,
                },
            );

            const resultTextClassname = classnames(
                `ra-strategy-modal-card__results`,
                {
                    [`ra-strategy-modal-card--hidden`]:
                        newResultCard !== id && oldResultCard !== id,
                },
            );
            const resultText =
                newResultCard === id ? (
                    <FormattedText value="raStrategyModalItem-raStrategyModalItem_newResult" />
                ) : oldResultCard === id ? (
                    <FormattedText value="raStrategyModalItem-raStrategyModalItem_oldResult" />
                ) : null;

            const availableRiskClassname = classnames(
                `ra-strategy-modal-card__building-${id}__available__risk`,
            );

            return (
                <div key={id} className={currentClassname}>
                    <p className={resultTextClassname}>{resultText}</p>
                    <div className={containerClassname}>
                        <p className={availableRiskClassname}>{riskText}</p>
                        <p className={countrySelectedClassname}>
                            {countryLabel}
                        </p>
                    </div>
                </div>
            );
        });

        return (
            <div className="ra-strategy-modal-cards">
                <div>{mappedItems}</div>
            </div>
        );
    }
}

RAStrategyModalCards.propTypes = {
    newResultCard: PropTypes.number.isRequired,
    oldResultCard: PropTypes.number.isRequired,
    allDisabled: PropTypes.bool,
};

RAStrategyModalCards.defaultProps = {
    allDisabled: false,
};

module.exports = RAStrategyModalCards;
